import { render, staticRenderFns } from "./PaymentDetailsModal.vue?vue&type=template&id=1de12c18"
import script from "./PaymentDetailsModal.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports